import { xray } from 'lib/xray';
import { disableAdsLogger } from 'reactApp/appHelpers/featuresHelpers/features/overquotaCommunications';
import { overquotaThresholdLabel } from 'reactApp/appHelpers/featuresHelpers/features/overquotaStates';
import { getUserOverquotaState } from 'reactApp/modules/profile/profile.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { getTabTariffsHash } from 'reactApp/sections/QuotaLanding/MultiTariffsList/MultiTariffsList.helpers';
import { store as reduxStore } from 'reactApp/store';
import type { TariffByModalTab } from 'reactApp/ui/TariffsModal/TariffsModalContent.types';
import { getPlatformInfo } from 'reactApp/utils/gaHelpers';
import { captureException } from 'reactApp/utils/tracer';

export const sendTariffsHash = ({
    tariffs,
    paySource,
    tariffsNumber,
}: {
    tariffs: TariffByModalTab[];
    paySource?: string;
    tariffsNumber?: string;
}) => {
    const state = reduxStore.getState();
    const quotaState = getUserOverquotaState(state);
    const isOverquota = UserQuotaSelectors.isOverquota(state);
    const overquotaState = quotaState?.status === 'failed' ? 'failedapi' : quotaState?.state;
    const threshold = UserSelectors.getUserThreshold(state);
    const noThreshold = !threshold && threshold !== 0;

    const tariffsInfo = getTabTariffsHash(tariffs);

    disableAdsLogger.info('hashes', { tariffsInfo, threshold, overquotaState, isOverquota });

    if (noThreshold) {
        captureException(null, {
            message: 'No threshold',
            issueKey: 'disableAds/threshold',
            threshold: String(threshold),
        });
    }

    const dwhData = {
        hash: tariffsInfo.hash,
        overq: isOverquota,
        th: noThreshold ? 'none' : threshold,
        state: overquotaState || 0,
        paySource: paySource || 'none',
        tariffs: Number(tariffsNumber) || 'none',
        label: overquotaThresholdLabel || 'none',
        platform: getPlatformInfo().join('_'),
    };

    const dwh_enabled_fields: (keyof typeof dwhData)[][] = [
        ['label', 'state', 'overq', 'th', 'hash', 'platform'],
        ['label', 'paySource', 'tariffs', 'hash'],
    ];

    xray.send('buy-disable-ads-hash', {
        p: 'cloud',
        dwh_enabled: true,
        dwh_enabled_fields,
        dwh: dwhData,
    });
};
